import React from 'react';
import Building from '../../../../icons/BusinessType/Building';
import Consulting from '../../../../icons/BusinessType/Consulting';
import Forbidden from '../../../../icons/BusinessType/Forbidden';
import HomeOffice from '../../../../icons/BusinessType/HomeOffice';
import Laptop from '../../../../icons/BusinessType/Laptop';
import Security from '../../../../icons/BusinessType/Security';
import BusinessOptionCard from './BusinessTypeCard';
import PolicyStepsHeader from '../../../../../components/common/PolicyStepsHeader';
import PolicyFormProgressBar from '../../../../common/PolicyFormProgressBar';
import useWidgetStore, { CurrentTabEnum, } from '../../../../../stores/widgetStore';
export default function BusinessTypeSelection() {
    var _a = useWidgetStore(), setModalOpen = _a.setModalOpen, setSelectedQuote = _a.setSelectedQuote, setCurrentTab = _a.setCurrentTab, selectedBusinessTypeOptions = _a.selectedBusinessTypeOptions, setBusinessTypeSelectedOptions = _a.setBusinessTypeSelectedOptions;
    var handleSelection = function (id) {
        setBusinessTypeSelectedOptions(id);
    };
    var options = [
        {
            id: 'service',
            label: (React.createElement(React.Fragment, null,
                "Provides a ",
                React.createElement("span", { className: "font-semibold" }, "service"),
                " or regularly gives ",
                React.createElement("span", { className: "font-semibold" }, "advice"))),
            icon: React.createElement(Consulting, null)
        },
        {
            id: 'equipment',
            label: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "font-semibold" }, "Has business equipment "),
                " ",
                React.createElement("br", null),
                "(laptops, furniture, tools, etc.)")),
            icon: React.createElement(Laptop, null)
        },
        {
            id: 'data',
            label: (React.createElement(React.Fragment, null,
                "Stores ",
                React.createElement("span", { className: "font-semibold" }, "sensitive data"),
                " (credit card, social security numbers, etc.)")),
            icon: React.createElement(Security, null)
        },
        {
            id: 'building',
            label: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "font-semibold" }, "Owns the building "),
                " we operate from")),
            icon: React.createElement(Building, null)
        },
        {
            id: 'home',
            label: (React.createElement(React.Fragment, null,
                "Primarily ",
                React.createElement("span", { className: "font-semibold" }, "operates from home"),
                ", a client's premises, or a space we don't own")),
            icon: React.createElement(HomeOffice, null)
        },
        {
            id: 'none',
            label: React.createElement(React.Fragment, null, "None of these"),
            icon: React.createElement(Forbidden, null)
        },
    ];
    var handleClose = function () {
        setCurrentTab(CurrentTabEnum.POLICY);
        setSelectedQuote(null);
        setModalOpen(false);
    };
    var handleNext = function () {
        setCurrentTab(CurrentTabEnum.RECOMMENDED_POLICIES);
    };
    var handleDisable = function (optionId) {
        var isNoneSelected = selectedBusinessTypeOptions.includes('none');
        var isOtherSelected = selectedBusinessTypeOptions.some(function (opt) { return opt !== 'none'; });
        if (optionId === 'none') {
            return isOtherSelected;
        }
        return isNoneSelected;
    };
    return (React.createElement("div", { className: "flex flex-col min-h-full" },
        React.createElement("div", { className: "sticky top-0 left-0 right-0 w-full bg-white z-10" },
            React.createElement(PolicyStepsHeader, { steps: [
                    {
                        stepText: 'Coverage',
                        isStepActive: true,
                        isStepCompleted: false
                    },
                    {
                        stepText: 'Business Info',
                        isStepActive: false,
                        isStepCompleted: false
                    },
                    {
                        stepText: 'Review',
                        isStepActive: false,
                        isStepCompleted: false
                    },
                    {
                        stepText: 'Purchase',
                        isStepActive: false,
                        isStepCompleted: false
                    },
                ], backButtonText: "Close", handleClose: handleClose, handleNext: handleNext, nextButtonText: "Continue", isNextDisabled: selectedBusinessTypeOptions.length < 1 })),
        React.createElement("div", { className: "px-4 py-6 flex-grow flex flex-col" },
            React.createElement(PolicyFormProgressBar, { steps: 2, activeStep: 1 }),
            React.createElement("h2", { className: "text-3xl font-bold mt-6" }, "Does your business do any of the following?"),
            React.createElement("p", { className: "text-[#252846] font-normal text-base mt-1 mb-6" }, "Select all that apply and we'll show you the coverage you probably need."),
            React.createElement("div", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 flex-grow" }, options.map(function (option) { return (React.createElement(BusinessOptionCard, { key: option.id, icon: option.icon, text: option.label, disabled: handleDisable(option.id), selected: selectedBusinessTypeOptions.includes(option.id), onClick: function () { return handleSelection(option.id); } })); })))));
}
